export default __webpack_public_path__ + "static/media/2-cityline.c1d3acc5.png";